import { useFlags } from '@joor/launchdarkly-react-client-sdk'
import { useSelector } from 'react-redux'

import {
  isAccountTypeBrand as isBrandSelector,
  isLiteRetailer as isListeRetailerSelector,
  isProBrand as isProBrandSelector,
  isAccountTypeRetailer as isRetailerSelector,
} from 'store/currentUser/selectors'

import {
  DATA_SELF_SERVE,
  EXPORT_TEMPLATES,
  LIST_JOBS,
  SHOPIFY_INTEGRATION_CONFIG,
} from 'routes/paths'

import DropdownMenuTextLink from '../../DropdownMenuTextLink/DropdownMenuTextLink'
import {
  useGetBrandStyleIdentifier,
  useNewImageUploaderExperience,
} from '../../ProductsDropdown/navbarProductsDropdown.hooks'
import messages from 'features/Navbar/NavbarRevamp/constants/navbarRevamp.messages'
import { SettingsDropdownIds } from 'features/Navbar/NavbarRevamp/navbarRevamp.ids'

const IntegrationSettings = () => {
  const { retailIntegrationSettings, useImportModal } = useFlags()

  const isBrand = useSelector(isBrandSelector)
  const isProBrand = useSelector(isProBrandSelector)
  const isRetailer = useSelector(isRetailerSelector)
  const isLiteRetailer = useSelector(isListeRetailerSelector)

  const { loading: loadingStyleIdentifiers } = useGetBrandStyleIdentifier(
    isRetailer,
  )
  const { isEnabled, loading } = useNewImageUploaderExperience(
    loadingStyleIdentifiers,
  )

  if (isBrand && ((!loading && isEnabled) || useImportModal || isProBrand)) {
    return (
      <DropdownMenuTextLink
        to={isEnabled && !loading ? LIST_JOBS : EXPORT_TEMPLATES}
        message={messages.importsExports}
        id={SettingsDropdownIds.SettingsOptionIntegrations}
      />
    )
  }

  if (isRetailer) {
    const menuItems = []
    if (isLiteRetailer) {
      menuItems.push({
        to: SHOPIFY_INTEGRATION_CONFIG,
        message: messages.integrationSettings,
        id: SettingsDropdownIds.SettingsOptionShopify,
      })
    }
    if (retailIntegrationSettings && !isLiteRetailer) {
      menuItems.push({
        to: DATA_SELF_SERVE,
        message: messages.integrationSettings,
        id: SettingsDropdownIds.SettingsOptionIntegrations,
      })
    }
    return (
      <>
        {menuItems.map(({ to, message, id }) => (
          <DropdownMenuTextLink key={id} to={to} message={message} id={id} />
        ))}
      </>
    )
  }

  return null
}
export default IntegrationSettings
